import {formatFilesForFilterer, formatSearchCodebaseResults} from "./fileHandlerUtils.ts";
import {getFilteredFiles} from "../../../db/vectorDb/getFilteredFiles.ts";
import {addToolMessage} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/utils/utils.ts";
import {runOrQueueToolCall} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/handlers/appToolCallHandler/ide/ideToolCallHandler.ts";

export const handleGiveSearchCodebaseResults = async (data: any, llmRequestRefs: any, websocketRef: any, currentMessageRef: any, messagesSequenceRef: any, setMessages: any, messagesRef: any, updateElementInProgress: any, environmentObjRef: any) => {
    try {
        let returnedFileContents = JSON.parse(data[0]);
        const toolCallId = data[1];
        const isGatherContext = data[2] === 'true';

        const filtererFormattedFiles = formatFilesForFilterer(returnedFileContents);

        if (isGatherContext) {
            websocketRef.current.send(JSON.stringify({
                functionName: "toolAgent",
                args: {type: "appResults", files: returnedFileContents, filtererFormattedFiles, toolCallId}
            }));
            llmRequestRefs.current.toolCallQueue = llmRequestRefs.current.toolCallQueue.filter((toolCall: any) => toolCall.id !== toolCallId);
            await runOrQueueToolCall(llmRequestRefs, "trigger", environmentObjRef, null, null, null);
            return;
        }

        const { id, name, args } = llmRequestRefs.current.toolCalls[toolCallId];
        if (filtererFormattedFiles) {
            returnedFileContents = await getFilteredFiles(args.query, filtererFormattedFiles, returnedFileContents);
        }

        const formattedCodebaseResults = formatSearchCodebaseResults(returnedFileContents, llmRequestRefs, setMessages, toolCallId);
        addToolMessage({ id, name, args }, {toolString: formattedCodebaseResults}, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);

        updateElementInProgress(toolCallId, 'delete');
        llmRequestRefs.current.toolCallQueue = llmRequestRefs.current.toolCallQueue.filter((toolCall: any) => toolCall.id !== toolCallId);
        await runOrQueueToolCall(llmRequestRefs, "trigger", environmentObjRef, null, null, null);
    } catch (error) {
        console.error("Error in handleGiveSearchCodebaseResults:", error);
    }
};